import {GenericService, ResultType} from '@/shared/xhttp';
import {DevisElementsList} from '@/models';

export class DevisElementsListService extends GenericService<DevisElementsList> {
}